export type Lang = 'pt' | 'en' | 'es';

const STORAGE_KEY = 'brup_lang';

const DICT = {
  pt: {
    home: 'Voltar para a página inicial',
    brandSub: 'Orçamento no celular',
    forProviders: 'Para quem faz serviço',
    heroTitle: 'Manda o orçamento no WhatsApp e recebe o sinal na sua chave Pix.',
    heroText: 'Três passos no celular: o serviço, o valor e o link. O cliente abre a proposta e copia o Pix. O dinheiro cai na chave do prestador. O ZapOrca não vê o pagamento e não confirma o banco.',
    ctaNew: 'Fazer um orçamento',
    ctaPanel: 'Abrir meu painel',
    cardPhoneTitle: 'No celular',
    cardPhoneText: 'O orçamento fica neste aparelho. Conta não é obrigatória.',
    cardWhatsTitle: 'Link no WhatsApp',
    cardWhatsText: 'A mensagem sai do seu WhatsApp, pelo wa.me, com o link da proposta.',
    cardPixTitle: 'Pix na sua chave',
    cardPixText: 'O código usa a chave que você cadastrou. Depois você marca que recebeu o sinal.',
    portalBefore: 'Parte do portal',
    portalAfter: 'As ferramentas grátis continuam sem conta. O ZapOrca é uma porta separada.',
    langLabel: 'Idioma',
    themeToDark: 'Mudar para o tema escuro',
    themeToLight: 'Mudar para o tema claro',
    themeDarkOn: 'Tema escuro ativado',
    themeLightOn: 'Tema claro ativado',
    newQuote: 'Novo Orçamento',
    cancel: 'Cancelar',
    panel: 'Painel',
    clientMarked: 'O prestador marcou o sinal',
    clientMarkedText: 'Isso não é uma confirmação do banco. O prestador conferiu o recebimento na chave Pix dele.',
    pixSheetNote: 'O ZapOrca não confirma o pagamento. O prestador confere no app do banco.',
    preparedFor: 'Proposta preparada para',
  },
  en: {
    home: 'Back to the home page',
    brandSub: 'Quote on your phone',
    forProviders: 'For people who do the work',
    heroTitle: 'Send the quote on WhatsApp and take the deposit on your Pix key.',
    heroText: 'Three steps on your phone: the job, the price and the link. The client opens the proposal and copies the Pix code. The money lands on the provider’s key. ZapOrca does not see the payment and does not confirm the bank.',
    ctaNew: 'Make a quote',
    ctaPanel: 'Open my panel',
    cardPhoneTitle: 'On this phone',
    cardPhoneText: 'The quote stays on this device. An account is not required.',
    cardWhatsTitle: 'WhatsApp link',
    cardWhatsText: 'The message leaves from your WhatsApp, via wa.me, with the proposal link.',
    cardPixTitle: 'Pix on your key',
    cardPixText: 'The code uses the key you saved. Afterwards you mark that you received the deposit.',
    portalBefore: 'Part of the portal',
    portalAfter: 'The free tools still need no account. ZapOrca is a separate door.',
    langLabel: 'Language',
    themeToDark: 'Switch to dark theme',
    themeToLight: 'Switch to light theme',
    themeDarkOn: 'Dark theme on',
    themeLightOn: 'Light theme on',
    newQuote: 'New quote',
    cancel: 'Cancel',
    panel: 'Panel',
    clientMarked: 'The provider marked the deposit',
    clientMarkedText: 'This is not a bank confirmation. The provider checked the receipt on their own Pix key.',
    pixSheetNote: 'ZapOrca does not confirm the payment. The provider checks it in the bank app.',
    preparedFor: 'Proposal prepared for',
  },
  es: {
    home: 'Volver a la página inicial',
    brandSub: 'Presupuesto en el celular',
    forProviders: 'Para quien hace el servicio',
    heroTitle: 'Manda el presupuesto por WhatsApp y recibe la seña en tu clave Pix.',
    heroText: 'Tres pasos en el celular: el servicio, el valor y el enlace. El cliente abre la propuesta y copia el Pix. El dinero cae en la clave del prestador. ZapOrca no ve el pago y no confirma el banco.',
    ctaNew: 'Hacer un presupuesto',
    ctaPanel: 'Abrir mi panel',
    cardPhoneTitle: 'En el celular',
    cardPhoneText: 'El presupuesto queda en este aparato. La cuenta no es obligatoria.',
    cardWhatsTitle: 'Enlace de WhatsApp',
    cardWhatsText: 'El mensaje sale de tu WhatsApp, por wa.me, con el enlace de la propuesta.',
    cardPixTitle: 'Pix en tu clave',
    cardPixText: 'El código usa la clave que guardaste. Después marcas que recibiste la seña.',
    portalBefore: 'Parte del portal',
    portalAfter: 'Las herramientas gratis siguen sin cuenta. ZapOrca es una puerta aparte.',
    langLabel: 'Idioma',
    themeToDark: 'Cambiar al tema oscuro',
    themeToLight: 'Cambiar al tema claro',
    themeDarkOn: 'Tema oscuro activado',
    themeLightOn: 'Tema claro activado',
    newQuote: 'Nuevo presupuesto',
    cancel: 'Cancelar',
    panel: 'Panel',
    clientMarked: 'El prestador marcó la seña',
    clientMarkedText: 'Esto no es una confirmación del banco. El prestador revisó el recibo en su clave Pix.',
    pixSheetNote: 'ZapOrca no confirma el pago. El prestador lo revisa en la app del banco.',
    preparedFor: 'Propuesta preparada para',
  },
} as const;

export type CopyKey = keyof typeof DICT.pt;

export function getLanguage(): Lang {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'pt' || saved === 'en' || saved === 'es') return saved;
  } catch {
    /* storage bloqueado */
  }
  const browser = (navigator.language || 'pt').toLowerCase();
  if (browser.startsWith('en')) return 'en';
  if (browser.startsWith('es')) return 'es';
  return 'pt';
}

export function setLanguage(lang: Lang): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* segue só nesta pintura */
  }
  document.documentElement.lang = lang === 'pt' ? 'pt-BR' : lang;
}

export function t(key: CopyKey): string {
  const lang = getLanguage();
  return DICT[lang][key];
}
